export default __webpack_public_path__ + "static/media/minusIcon.39718590.svg";